var plugin_rtlignore_default = {
  "alignLeft": "qtGpt",
  "textWrapNowrap": "xgm3u",
  "alignRight": "t5e5p",
  "alignCenter": "_6glEI",
  "sizeFullWidth": "U5-yG",
  "renderedInTable": "nrN5M",
  "sizeOriginal": "-ZY60",
  "sizeContent": "P0mQ0",
  "sizeSmall": "BummT",
  "sizeSmallCenter": "E8EZc",
  "flex": "_4hhZh",
  "atomic": "HTb88",
  "embed": "LZTWI",
  "horizontalScrollbar": "pyvQ2",
  "pluginContainerMobile": "gJtyJ"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
